import React from 'react';
import Typography from '@material-ui/core/Typography';

export function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {`Copyright © ${process.env.REACT_APP_COURIER_COMPANY_NAME} ${new Date().getFullYear()}.`}
    </Typography>
  );
}
